/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M9.625 5.49a1 1 0 0 1 0 1.414l-4.083 4.082h15.322a1 1 0 1 1 0 2H5.514l4.11 4.11a1 1 0 1 1-1.413 1.415l-5.767-5.767a1.052 1.052 0 0 1 0-1.488L8.21 5.49a1 1 0 0 1 1.414 0Z"
})), "0 0 24 24", "ArrowBack");